<div class="relative">
    <input
        #passwordInput
        [type]="showPassword ? 'text' : 'password'"
        [class]="customClass || 'w-full px-3 sm:px-4 py-2.5 sm:py-3 pr-12 text-base border rounded-3xl focus:outline-none'"
        [value]="value"
        (input)="onInputChange($any($event.target).value)"
        (blur)="onBlur()"
        (keydown)="onKeydown($event)"
        [placeholder]="placeholder"
        [tabindex]="tabindex"
        [disabled]="disabled" />
    <button
        type="button"
        (click)="togglePasswordVisibility()"
        class="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none min-h-[44px] min-w-[44px] flex items-center justify-center"
        [tabindex]="-1">
        <ng-icon *ngIf="!showPassword" name="ionEyeOutline" class="text-lg sm:text-xl"></ng-icon>
        <ng-icon *ngIf="showPassword" name="ionEyeOffOutline" class="text-lg sm:text-xl"></ng-icon>
    </button>
</div>
